export default import.meta.ROLLDOWN_FILE_URL_YD4ZpDLemYmvNVhhWopmPA